<template>
    <div class="news-item" v-on:click="viewNewsItem">
      <div class="top-bar">
        
        <div class="title">
          <ui-icon v-if="item.sticky==1" backgroundColor="transparent" color="#8CC63E" icon='thumbtack' class="thumbtack"/>
          {{item.title}}
        </div>
        
         
       
        <div v-if="showEditorIcons()" class="icons">
          <ui-icon class="icon" v-on:click.native.stop.prevent="editNewsitem" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>&nbsp;
          <ui-icon class="icon" v-on:click.native.stop.prevent="deleteNewsitem"  backgroundColor="#F46767" color="#FFFFFF" icon="times"/>
        </div>
      </div>


    
      <div class="poster-name">
       <news-status-chip :item="item"/>
        {{item.poster_name}}
      </div>
      <div class="date">{{item.date}}</div>
     
      <div class="flex-container">

       

        <div v-if="item.f_img" class="img-container">
           
          <ratio-image :src="item.f_img">
          </ratio-image>

        </div>


         <div v-if="item.video_count || item.photo_count || item.pdf_count || item.mp3_count" class="counters">
              <ui-chip v-if="item.video_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="film">{{item.video_count}}</ui-chip>
              <ui-chip v-if="item.photo_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="image">{{item.photo_count}}</ui-chip>
              <ui-chip v-if="item.pdf_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="file-pdf">{{item.pdf_count}}</ui-chip>
              <ui-chip v-if="item.mp3_count" backgroundColor="rgba(0,0,0,.4)" color="white" class="counter-icon" icon="music">{{item.mp3_count}}</ui-chip>
          </div>
        


        <div class="text-container">
          <div class="intro">{{createIntroText(item.content)}}</div>
          <div class="lees-meer">{{$t('language.lees_meer')}}</div>
        </div>
      </div>


      



    </div>
</template>

<script>

import { mapState } from 'vuex';
import UiIcon from '../UiIcon.vue';
import RatioImage from '../../components/RatioImage.vue';
import { helper } from '../../services/Helper.js';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import NewsStatusChip from '../../components/news/NewsStatusChip.vue';
import UiChip from '../UiChip.vue';

export default {
  name: 'news-list-item',
  props:{
    item:undefined,
  },
  data:function(){
    return {
      group_id:this.$route.params.id,
      feed:this.$route.params.feed,
    }
  },
  computed:{
     ...mapState([
       'appSettings','user_schools','group'
       ]),
  },
  components:{
    UiIcon,
    RatioImage,
    NewsStatusChip,
    UiChip,
  },
  methods:{
    getStatusColor(status){
      switch(status){
        case "pending": return "#ffbc00"
        case "rejected": return "#FF0000"
        case "approved": return "#03d800"
        case "draft": return "#c5c5c5"
      }
    },
    viewNewsItem(){
      this.$router.push({path:"/news_item/"+this.item.id})
    },
    editNewsitem(){
      
      this.$router.push({path:"/group/"+this.group_id+"/news_item/"+this.item.id+'/update/'})
    },
    deleteNewsitem(){

      var payload={
        id:this.item.id,
        news_id:(this.group_id!=0) ? this.group.news_id : 0, // group_id is 0 then return 0 else return news_id
        feed:this.feed,
      }

      this.$store.dispatch('delete_news_item',payload);
    },
    createIntroText(txt){
         return helper.getExcerpt(txt);
    },
    showEditorIcons(){
      var school;

      // todo: news_item user_email vergelijken met school.username
        if(!this.group.authorized && this.group_id>0){
          return false;
        }
        if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          school = this.user_schools.find(school => school.active === 1);
          
          if(school.username==this.item.user_email){
            return true;
          }else{
            return false;
          }
        }
        if(this.appSettings.user_level==USER_LEVEL.ADMIN){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.TEACHER){

          if(this.group_id==0){
            // check if i am 'me'
              school = this.user_schools.find(school => school.active === 1);
            
            if(school.username==this.item.user_email){
              return true;
            }else{
              return false;
            }
          }else{
            return true;
          }
          
        }
        if(this.appSettings.user_level==USER_LEVEL.PARENT){
          return false;
        }
        return false;
        

      },
      
  },
  
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbtack{
  font-size:initial;
}
.icons{
  display: flex;
  justify-content: center;
}
.icon{
  margin-left:5px;
}
.news-item{
  cursor:pointer;
  color:inherit;
  margin-bottom:20px;
  padding-bottom:10px;
  border-bottom:1px solid #DDDDDD;
}

img{
  border-radius:2px;
}

.news-item .lees-meer{
  font-weight:bold;
  color:#707070;
  font-size:.8em;
}
.news-item .top-bar{
  display:flex;
  justify-content: center;
  align-items: center;
}
.news-item .top-bar .title{
  flex:1;
  font-size:1.5em;
}

.news-item .poster-name{
  font-size:.7em;
  font-weight:bold;
}
.news-item .date{
  font-size:.7em;
  margin-bottom:10px;
}
.news-item .img-container{
  background-color:#EEEEEE;
  position:relative;
  overflow:hidden;
  /*display:flex;
  justify-content: center;
  align-items: center;
  */
  margin-bottom:5px;
}
.news-item .poster-img{
  display:block;
  position:absolute;
  width: 100%;
  height: auto;
}
.news-item .ratio-img{
  display:block;
  position:relative;
  width: 100%;
  height: auto;
}

.intro{
  margin-bottom:25px;
}

.counters{
  text-align:right;
  font-size:1em;
  margin-bottom:25px;
}
.counter-icon{
  margin-right:3px;
}
</style>

